import { render, staticRenderFns } from "./completesignup.vue?vue&type=template&id=00053584"
import script from "./completesignup.vue?vue&type=script&lang=js"
export * from "./completesignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports